
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

//Design
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./screens/dashboard/Dashboard";
import Health from "./screens/health/Health";
import Navbar from "./layouts/Navbar";
import Performance from "./screens/performance/Performance";
import Security from "./screens/security/Security";
import Landing from "./screens/Landing";
import Admin from "./screens/admin/Admin";
import Redirect from "./layouts/Redirect";
import Authenticated from "./layouts/Authenticated";
import Fusion from "./screens/3DFusion/3DFusion";
import Chatbot from "./screens/chatbot/Chatbot";
import Opensource from "./screens/opensource/Opensource";
import Portfolio from "./screens/portfolio/Portfolio";
import Sustainability from "./screens/sustainability/Sustainability";
import SustainabilityDetailEmployeeSatisfaction from "./screens/sustainability/components/SustainabilityDetailEmployeeSatisfaction";
import SustainabilityDetailEnvironment from "./screens/sustainability/components/SustainabilityDetailEnvironment";
import SustainabilityDetailEnergy from "./screens/sustainability/components/SustainabilityDetailEnergy";
import SustainabilityDetailCarbon from "./screens/sustainability/components/SustainabilityDetailCarbon";
import { getClientConfig } from "./actions/clientConfigAction";


const App = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.dark.data);
  const clientConfig = useSelector((state) => state.clientConfig);
  const [domain, setDomain] = useState("");
  const [activeTab, setActiveTab] = useState("overview");
  const [tabContent, setTabContent] = useState(null);

  const getDomain = () => {
    const hostname = window.location.hostname;
    return hostname.split(".")[0];
  };


// First effect to fetch data
useEffect(() => {
  dispatch(getClientConfig());
}, [dispatch]);

// Second effect to process data once available
useEffect(() => {
  if (!clientConfig || !clientConfig.config) {
    return; // Exit early if data isn't loaded yet
  }
  
  //== Development
  if (
    process.env.NODE_ENV === "development"
  ) {
    setDomain(clientConfig.config.configDomain);
  } 
  //== Production-Stagging Slot
  else if (clientConfig.config.deploymentSlot === "stagging") {
    setDomain(clientConfig.config.configDomain);
  }
  //== Production-Production Slot
  else {
    setDomain(getDomain());
  }
}, [clientConfig]); 


  return (
    <div className="h-100 w-100" data-theme={dark ? "dark" : ""}>
      <Router>
        <Navbar
          domain={domain}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setTabContent={setTabContent}
        />
        <main className="h-100 w-100 nav-padding">
          <Routes>
            <Route path="/" element={<Landing domain={domain} />} />
            <Route path="/redirect" element={<Redirect />} />
            <Route
              path="/dashboard"
              element={
                <Authenticated Component={() => 
                  <Dashboard
                    domain={domain}
                    activeTab={activeTab}
                    tabContent={tabContent}
                  />
                } />
              }
              exact
            />
            {/* Test */}
            <Route path="/health" element={<Authenticated Component={Health} />} />
            <Route path="/performance" element={<Authenticated Component={Performance} />} />
            <Route path="/security" element={<Authenticated Component={Security} />} />
            <Route path="/sustainability" element={<Authenticated Component={Sustainability} />} />
            <Route
              path="/sustainability/employeesatisfaction"
              element={<Authenticated Component={SustainabilityDetailEmployeeSatisfaction} />}
            />
            <Route
              path="/sustainability/environment"
              element={<Authenticated Component={SustainabilityDetailEnvironment} />}
            />
            <Route
              path="/sustainability/energy"
              element={<Authenticated Component={SustainabilityDetailEnergy} />}
            />
            <Route
              path="/sustainability/carbon"
              element={<Authenticated Component={SustainabilityDetailCarbon} />}
            />
            <Route path="/3dfusion" element={<Authenticated Component={Fusion} />} />
            <Route path="/chatbot" element={<Authenticated Component={Chatbot} />} />
            <Route path="/opensource" element={<Authenticated Component={Opensource} />} />
            <Route path="/portfolio" element={<Authenticated Component={Portfolio} />} />

            <Route path="/admin/users" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/users/add" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/users/edit" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/users/userId/:id" element={<Authenticated Component={Admin} />} />

            <Route path="/admin/clients" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/clients/add" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/clients/edit" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/clients/clientId/:id" element={<Authenticated Component={Admin} />} />

            <Route path="/admin/buildings" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/buildings/add" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/buildings/edit" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/buildings/buildingId/:id" element={<Authenticated Component={Admin} />} />

            <Route path="/admin/floors" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/floors/add" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/floors/edit" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/floors/floorId/:id" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/rooms/floorId/:id" element={<Authenticated Component={Admin} />} />

            <Route path="/admin/configs" element={<Authenticated Component={Admin} />} />

            {/* Project routes */}
            <Route path="/admin/projects" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/projects/add" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/projects/edit" element={<Authenticated Component={Admin} />} />
            <Route path="/admin/projects/clientId/:id" element={<Authenticated Component={Admin} />} />
          </Routes>
        </main>
      </Router>
    </div>
  );
};

export default App;
